import { FC } from "react";
import { charData } from "../../../BusinessChars/BussinessCharCard/BusinessCharCard";
import { IBusinessElementDependency } from "../../../../../../redux/businesses";
import { BusinessElementDependency } from "../BusinessElementDependency/BusinessElementDependency";
import styles from './BusinessElementState.module.scss';
import upgradeIcon from '../icons/upgrade.png';
import areaIcon from "../../../icons/area.png";
import staffIcon from "../../../icons/staff.png";
import areaBlockIcon from "../../../icons/area-block.png";
import staffBlockIcon from "../../../icons/staff-block.png";
import lockIcon from "./icons/lock.png";

export enum BusinessElementStateType {
    Current,
    Next,
    Max,
}

interface IBusinessElementStateProps {
    type: BusinessElementStateType;
    elementType: number;
    level: number;

    profit?: number;
    area?: number;    
    staff?: number;

    areaLimited?: boolean;
    staffLimited?: boolean;
    dependency?: IBusinessElementDependency;
    isAllowUpgrade?: boolean;
}

export const BusinessElementState: FC<IBusinessElementStateProps> = (
    { type, elementType, level, profit, area, areaLimited, staff, staffLimited, dependency, isAllowUpgrade }
) => {    
    const isCurrentLevel = () => type === BusinessElementStateType.Current;

    const isBlocked = () => isAllowUpgrade === false;

    const getLevelBlock = () => {
        if (isBlocked())
            return (
                <div className={styles.levelValueBlock}>
                    <div className={styles.lockBlock}>
                        <img alt='lock' src={lockIcon} />
                    </div>
    
                    { dependency && <BusinessElementDependency { ...dependency } elementType={ elementType } /> }
                </div>
            );

        return (
            <div className={styles.levelValue}>
                { level }
                { dependency && <BusinessElementDependency { ...dependency } elementType={ elementType } /> }
            </div>
        );
    }

    return (
        <div>
            <span className={styles.levelTitle}>
                { isCurrentLevel() ? 'Ваш уровень' : 'Следующий уровень' }
            </span>

            <div className={ isCurrentLevel() ? styles.levelBlock : styles.levelBlockNext }>                
                { getLevelBlock() }

                <div className={ !isBlocked() ? styles.income : styles.incomeBlock }>
                    <img alt='currency' src={upgradeIcon} className={styles.currency} />{" "}
                    <span>{profit} в час</span>
                </div>

                <div className={styles.stats}>
                    <div className={`${styles.statItem} ${areaLimited ? styles.block : ''}`}>
                        <img alt='area' src={areaLimited ? areaBlockIcon : areaIcon} className={styles.icon} />
                        {`${area} ${charData.area.unit}`}
                    </div>

                    <div className={`${styles.statItem } ${staffLimited ? styles.block : ''}`}>
                        <img alt='staff' src={staffLimited ? staffBlockIcon : staffIcon} className={styles.icon} />
                        {`${staff} ${charData.staff.unit}`}
                    </div>
                </div>
            </div>
        </div>
    );
}